import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { NavController, MenuController } from '@ionic/angular';
import { AppService } from '../../services/app.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Input() page;
  @Output() getData: EventEmitter<string> = new EventEmitter<string>();

  constructor(private navCtrl: NavController, public app: AppService) {}

  ngOnInit() {}

  viewPage(m) {
    this.navCtrl.navigateRoot('/' + m);
  }

  getCompany() {
    var item = this.app.sysData.userAccess.find(
      (x) => x.id == this.app.sysData.company_id
    );
    this.app.sysData.company = JSON.parse(JSON.stringify(item));
    this.getData.emit();
  }
}
